export const mockProducts = [
  // ============ MACHINES OUTILS ============
  // Ajoutez ici d'autres produits de la catégorie "Machines Outils"

  {
    id: "mi-008",
    name: "Tour à métaux manuel",
    description:
      "Tour manuel robuste pour l'usinage de précision des pièces métalliques.",
    image:
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743511024/ED1000GDIG-Tour-a-metaux-a-affichage-Numerique-Entre-poi-show-full_1_uuutdq.jpg",
    gallery: [
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743511024/Tour-a-Metaux-avec-Affichage-Digital-ED1000-GDIG-show-full_lek3h8.jpg",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743511023/ED1000GDIG-Accessoires-fournis-avec-le-tour-a-metaux-show-full_crlutl.jpg",
    ],
    price: 12000,
    monthlyPayment: 399.99,
    paymentPeriods: "12, 24, 36 mois",
    installmentPayment: { amount: 1250, period: "mois" },
    category: "machines_industrielles",
    subcategory: "machines_outils",
    condition: "new",
    brand: "MetalWorks",
    specifications: {
      moteur: "2.2 kW",
      capacité: "Usinage de pièces jusqu'à 300 mm de diamètre",
      vitesse_max: "1500 RPM",
      contrôle: "Manuel",
      précision: "0.05 mm",
    },
    availableFinancing: ["Paiement Échelonné", "leasing"],
    availableDurations: ["12", "24", "36"],
    stock: 6,
  },
  {
    id: "mi-009",
    name: "Fraiseuse manuelle universelle",
    description:
      "Fraiseuse polyvalente pour les travaux d'usinage manuel sur métal et plastique.",
    image:
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743511117/FRAISEUSE_jr7fhb.jpg",
    gallery: [
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743511112/Capture02_lq5yme.png",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743511112/Capture02_lq5yme.png",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743511112/Capture_w3aufi.png",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743511115/Capture044_kyyudi.png",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743511114/Capture05_aekulr.png",
    ],
    price: 18000,
    monthlyPayment: 499.99,
    paymentPeriods: "12, 24, 36 mois",
    installmentPayment: { amount: 1500, period: "mois" },
    category: "machines_industrielles",
    subcategory: "machines_outils",
    condition: "new",
    brand: "PrecisionTools",
    specifications: {
      moteur: "3.0 kW",
      capacité: "Table de 800 x 300 mm",
      vitesse_max: "2000 RPM",
      contrôle: "Manuel",
      précision: "0.02 mm",
    },
    availableFinancing: ["Paiement Échelonné", "leasing"],
    availableDurations: ["12", "24", "36"],
    stock: 4,
  },

  // Machines de Production
  {
    id: "mi-004",
    name: "Presses hydrauliques de production",
    description:
      "Presses à haute capacité pour la fabrication de pièces métalliques",
    image:
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743513947/H138f0ea575e14a28b2ce55fe30f7a8cdV.jpg_720x720q50_cgayfi.png",
    gallery: [
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743513945/H1d07ed207c5c40a68c9b9c6c551d4a17D.jpg_720x720q50_go84ea.png",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743513949/H8667109d10b745b29722490aaa9f36f1F.jpg_720x720q50_ucg8ir.png",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743513953/Hd9a3195b67e940f88814ca964703a949A.jpg_720x720q50_wv7445.png",
    ],
    price: 2000,
    monthlyPayment: 49.99,
    paymentPeriods: "24, 36, 48 mois",
    installmentPayment: { amount: 83.33, period: "mois" },
    category: "machines_industrielles",
    subcategory: "machines_production",
    condition: "new",
    brand: "Industrial Presses Inc.",
    specifications: {
      capacité: "2000 tonnes",
      pression_max: "2000 bar",
      contrôle: "Automatique",
    },
    availableFinancing: ["Paiement Échelonné", "leasing"],
    availableDurations: ["24", "36", "48"],
    stock: 1,
  },

  // Machines Textiles
  {
    id: "mi-005",
    name: "Machine à tisser automatique",
    description: "Machine de production textile pour tissage rapide et précis",
    image:
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743595313/07_u0u84h.png",
    gallery: [
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743595321/10_zy2ztt.png",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743595314/08_cxbflo.png",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743595313/09_x9t7nb.png",
    ],
    price: 25000,
    monthlyPayment: 599.99,
    paymentPeriods: "12, 24, 36 mois",
    installmentPayment: { amount: 2083.33, period: "mois" },
    category: "machines_industrielles",
    subcategory: "machines_textile",
    condition: "new",
    brand: "TextileTech",
    specifications: {
      vitesse_max: "1000 mètres par minute",
      largeur_tissu: "2 m",
      contrôle: "Automatique",
    },
    availableFinancing: ["Paiement Échelonné", "leasing"],
    availableDurations: ["12", "24", "36"],
    stock: 5,
  },
  {
    id: "mi-010",
    name: "Usine de Fabrication de Fils de Cheveux Artificiels en Soie",
    description:
      "Usine clé en main pour la production de fils de cheveux artificiels en soie, adaptée aux besoins industriels.",
    image:
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743677843/Capture_aecugm.png",
    gallery: [
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743677843/03_bd9z7t.png",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743677842/05_txv97f.png",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743677842/02_dm7xdo.png",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743677841/06_bzbqmz.png",
    ],
    price: 100000,
    monthlyPayment: 2499.99,
    paymentPeriods: "12, 24, 36 mois",
    installmentPayment: { amount: 8333.33, period: "mois" },
    category: "machines_industrielles",
    subcategory: "usines_production",
    condition: "new",
    brand: "SilkHairTech",
    specifications: {
      capacité: "500 kg/jour",
      énergie: "Électrique",
      dimensions: "50m x 30m",
      caractéristiques: [
        "Machines de filature automatisées",
        "Système de contrôle qualité intégré",
        "Ligne d'emballage automatisée",
      ],
    },
    availableFinancing: ["Paiement Échelonné", "leasing"],
    availableDurations: ["12", "24", "36"],
    stock: 2,
  },
  // Machines Alimentaires

  {
    id: "ag-003",
    name: "Presse à Huile pour Arachide et Tournesol",
    description:
      "Machine compacte pour extraire l'huile des graines comme l'arachide, le soja et le tournesol.",
    image:
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743522310/Capture_fvxmjn.png",
    gallery: [
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743522310/04_j5cw0v.png",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743522310/03_uq13zf.png",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743522310/02_hdnmg2.png",
    ],
    price: 3000,
    monthlyPayment: 79.99,
    category: "machines_industrielles",
    subcategory: "machines_agroalimentaires",
    condition: "new",
    brand: "OilPressTech",
    specifications: {
      capacité: "50 kg/heure",
      puissance: "3 kW",
      rendement: "40-50%",
      usage: "Arachide, soja, tournesol",
    },
    availableFinancing: ["leasing", "Paiement Échelonné"],
    availableDurations: ["12", "24"],
    stock: 8,
  },
  {
    id: "ag-004",
    name: "Ligne de Production de Farine de Manioc",
    description:
      "Équipement complet pour transformer le manioc en farine de haute qualité.",
    image:
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743583343/001_dvlxam.png",
    gallery: [
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743583343/006_rwklsy.jpg",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743583342/002_fjjquq.jpg",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743583342/003_htqvls.jpg",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743583342/005_rpsqv7.jpg",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743583342/004_d7nrwz.jpg",
    ],
    price: 15000,
    monthlyPayment: 399.99,
    category: "machines_industrielles",
    subcategory: "machines_agroalimentaires",
    condition: "new",
    brand: "CassavaTech",
    specifications: {
      capacité: "500 kg/heure",
      étapes: "Lavage, râpage, séchage, broyage",
      énergie: "Électrique",
      usage: "Manioc",
    },
    availableFinancing: ["leasing", "Paiement Échelonné"],
    availableDurations: ["12", "24", "36"],
    stock: 3,
  },
  {
    id: "ag-005",
    name: "Mini-Ligne de Production de Biscuits",
    description:
      "Ligne compacte pour produire des biscuits à base de farine de manioc, maïs ou soja.",
    image:
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743585164/BISCUIT03_f6drfg.jpg",
    gallery: [
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743585165/BISCUIT_yk7b7a.png",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743585166/BISCUIT02_njvbrf.png",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743585168/BISCUIT04_alqtqb.png",
    ],
    price: 12000,
    monthlyPayment: 299.99,
    category: "machines_industrielles",
    subcategory: "machines_agroalimentaires",
    condition: "new",
    brand: "BiscuitLine",
    specifications: {
      capacité: "200 kg/heure",
      étapes: "Mélange, façonnage, cuisson, emballage",
      énergie: "Électrique",
      usage: "Farine de manioc, maïs, soja",
    },
    availableFinancing: ["leasing", "Paiement Échelonné"],
    availableDurations: ["12", "24", "36"],
    stock: 4,
  },

  //TRANSPORT

  {
    id: "vh-001",
    name: "Toyota Hiace",
    description:
      "Minibus polyvalent pour transport de passagers et de marchandises",
    image:
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743504784/001_b3feqr.jpg",
    gallery: [
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743504784/004_rbhyvs.jpg",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743504784/005_y0njog.jpg",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743504784/009_dxvvjt.jpg",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743504785/014_sbwjs2.jpg",
    ],
    price: 5000,
    monthlyPayment: 500,
    paymentPeriods: "12, 24, 36 mois",
    installmentPayment: { amount: 2916.67, period: "mois" },
    category: "vehicules",
    subcategory: "transport_en_commun",
    condition: "occasion",
    brand: "Toyota",
    specifications: {
      moteur: "2.8L Diesel",
      capacite: "14 places",
      transmission: "Manuelle 5 rapports",
    },
    availableFinancing: ["Paiement Échelonné", "leasing"],
    availableDurations: ["12", "24", "36"],
    stock: 5,
  },
  {
    id: "vh-002",
    name: "Toyota Land Cruiser",
    description: "Véhicule tout-terrain robuste adapté aux routes difficiles",
    image:
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743505268/6da9f7a6136a49cf0c3ef6912404d8bb_a3rfut.png",
    gallery: [
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743505270/54d33b444e64ce8933f006535b4cda90_fhrno3.png",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743505270/d0e833b98ca611d1040d86f0e9ad630c_ezytla.png",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743505269/7290bef7918d90a48eedb5251f9eb143_aa7mjl.jpg",
    ],
    price: 50000,
    monthlyPayment: 1599.99,
    paymentPeriods: "24, 36, 48 mois",
    installmentPayment: { amount: 6250, period: "mois" },
    category: "vehicules",
    subcategory: "vehicules_speciaux",
    condition: "new",
    brand: "Toyota",
    specifications: {
      moteur: "4.5L Diesel V8",
      transmission: "Automatique 6 rapports",
      capacite: "5 places",
    },
    availableFinancing: ["Paiement Échelonné", "leasing"],
    availableDurations: ["24", "36", "48"],
    stock: 3,
  },
  {
    id: "vh-003",
    name: "Toyota Noah",
    description: "Monospace familial avec grand confort et espace intérieur",
    image:
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743506057/003_1_uo6ua0.jpg",
    gallery: [
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743506057/008_p6tsth.jpg",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743506057/005_1_fw31t0.jpg",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743506057/002_1_oa90ag.jpg",
    ],
    price: 7000,
    monthlyPayment: 699.99,
    category: "vehicules",
    subcategory: "vehicules_utilitaires",
    condition: "occasion",
    brand: "Toyota",
    specifications: {
      moteur: "2.0L Essence",
      transmission: "CVT",
      capacite: "7 places",
    },
    availableFinancing: ["Paiement Échelonné", "leasing"],
    availableDurations: ["12", "24", "36"],
    stock: 4,
  },
  {
    id: "vh-004",
    name: "Toyota Fourgonnette Proace",
    description: "Fourgonnette spacieuse pour le transport de marchandises",
    image:
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743507376/09a82a95-7b21-4c8a-85e3-f3933b5b8c38_jihkaw.png",
    gallery: [
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743507374/5d98cc7c-153d-4c14-b2f2-26d0fa8a97f3_q9vngp.png",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743507378/862df5e8-2dcf-478a-b52e-35f3203f5652_pwkwvs.png",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743507374/3f66b6f1-8fd5-40ce-867d-8ab0f2e3b3c4_as9xpl.png",
    ],
    price: 8000,
    monthlyPayment: 249.99,
    category: "vehicules",
    subcategory: "vehicules_utilitaires",
    condition: "new",
    brand: "Toyota",
    specifications: {
      moteur: "2.0L Diesel",
      transmission: "Manuelle 6 rapports",
      capacite: "3 places + grande soute",
    },
    availableFinancing: ["Paiement Échelonné", "leasing"],
    availableDurations: ["12", "24", "36"],
    stock: 6,
  },
  {
    id: "vh-005",
    name: "Toyota Camionnette Hilux",
    description:
      "Pick-up robuste pour les usages professionnels et tout-terrain",
    image:
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743508337/gun125l-dnfsxn-g1_d849kz.png",
    gallery: [
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743508339/gun125l-dnfsxn-g2_artzx7.png",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743508339/gun125l-dnfsxn-g4_alkqd5.png",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743508340/gun125l-dnfsxn-g3_hljykd.png",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743508348/gun125l-dnfsxn-g9_c7ya9u.png",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743508349/gun125l-dnfsxn-g12_wde4go.png",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743508346/gun125l-dnfsxn-g20_dxxald.png",
    ],
    price: 17000,
    monthlyPayment: 400,
    category: "vehicules",
    subcategory: "vehicules_utilitaires",
    condition: "new",
    brand: "Toyota",
    specifications: {
      moteur: "2.8L Diesel",
      transmission: "Automatique 6 rapports",
      capacite: "Double cabine",
    },
    availableFinancing: ["Paiement Échelonné", "leasing"],
    availableDurations: ["12", "24", "36"],
    stock: 5,
  },
  {
    id: "vh-006",
    name: "Toyota Coaster",
    description: "Bus de transport collectif idéal pour les longues distances",
    image:
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743508054/8e3c585c1bdc4df4ff9700e1863d9405_uldbnn.png",
    gallery: [
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743508056/96f16f2a38efa7c91fc736b919e44cda_bm3q3w.png",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743508056/96f16f2a38efa7c91fc736b919e44cda_bm3q3w.png",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743508057/9b4045aec03465f2d8dd1f77649fa31b_hg8mup.png",
    ],
    price: 25000,
    monthlyPayment: 599.99,
    category: "vehicules",
    subcategory: "transport_en_commun",
    condition: "new",
    brand: "Toyota",
    specifications: {
      moteur: "4.0L Diesel",
      transmission: "Automatique 6 rapports",
      capacite: "30 places",
    },
    availableFinancing: ["Paiement Échelonné", "leasing"],
    availableDurations: ["24", "36", "48"],
    stock: 3,
  },
  {
    id: "vh-007",
    name: "Moto Tricycle",
    description:
      "Moto tricycle idéale pour le transport de marchandises en ville",
    image:
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743508589/150cc-gasoline-3-wheel-cargo-motorcycle14d55_lwf1at.png",
    gallery: [
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743508589/150cc-gasoline-3-wheel-cargo-motorcycle1ef58_z41elb.png",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743508590/150cc-gasoline-3-wheel-cargo-motorcycle04393_rwfeov.png",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743508589/150cc-gasoline-3-wheel-cargo-motorcycle2c060_f88ig4.png",
    ],
    price: 3000,
    monthlyPayment: 199.99,
    category: "vehicules",
    subcategory: "motos",
    condition: "new",
    brand: "Giant Motors",
    specifications: {
      moteur: "150cc",
      transmission: "Automatique",
      capacite: "2 places",
      usage: "Transport de marchandises et passagers",
    },
    availableFinancing: ["Paiement Échelonné", "leasing"],
    availableDurations: ["12", "24"],
    stock: 8,
  },
  {
    id: "vh-008",
    name: "Mitsubishi Canter Camion Frigorifique",
    description:
      "Camion frigorifique pour le transport de produits périssables.",
    image:
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743591892/BX482642_15dc3edb_r3crai.jpg",
    gallery: [
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743591892/BX482642_15dc3edc_iraxqk.jpg",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743591907/BX482642_15dc3eee_dhajpv.jpg",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743591903/BX482642_15dc3eed_kgxplb.jpg",
    ],
    price: 18000,
    monthlyPayment: 899.99,
    category: "vehicules",
    subcategory: "vehicules_speciaux",
    condition: "new",
    brand: "Mitsubishi",
    specifications: {
      capacite: "5 tonnes",
      moteur: "3.0L Diesel",
      temperature: "-20°C à +10°C",
    },
    availableFinancing: ["Paiement Échelonné", "credit"],
    availableDurations: ["12", "24", "36"],
    stock: 6,
  },

  // ============ ÉQUIPEMENTS INFORMATIQUES ============
  {
    id: "it-001",
    name: "Routeur TP-Link Jetstream Professionnel",
    description: "Routeur gigabit pour PME avec gestion avancée du trafic",
    image:
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743428386/kiota_suit/Leasing/Equipements%20informatiques/reseaux/Routeur%20TP-Link%20Jetstream%20Professionnel/qxciuzmbh8g0ljo3xsof.png",
    gallery: [
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743428387/kiota_suit/Leasing/Equipements%20informatiques/reseaux/Routeur%20TP-Link%20Jetstream%20Professionnel/yw6qrau9wvpec1f5almo.png",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743428387/kiota_suit/Leasing/Equipements%20informatiques/reseaux/Routeur%20TP-Link%20Jetstream%20Professionnel/ruiebtedghu4nee1mhl5.png",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743428386/kiota_suit/Leasing/Equipements%20informatiques/reseaux/Routeur%20TP-Link%20Jetstream%20Professionnel/walhqlaimuydi8dsc0pk.png",
    ],
    price: 250,
    monthlyPayment: 12.99,
    paymentPeriods: "12, 24 mois",
    installmentPayment: { amount: 29.17, period: "mois" },
    category: "informatique",
    subcategory: "reseaux",
    condition: "new",
    brand: "TP-Link",
    specifications: {
      ports: "8x Gigabit",
      wifi: "AC1200",
      securite: "Pare-feu intégré",
    },
    availableFinancing: ["operational_lease"],
    availableDurations: ["12", "24"],
    stock: 8,
  },
  {
    id: "it-002",
    name: "Imprimante HP LaserJet Pro",
    description: "Imprimante laser monochrome avec impression rapide",
    image:
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743429529/kiota_suit/Leasing/Equipements%20informatiques/impression/Imprimante%20HP%20LaserJet%20Pro/c5frbpxoo6tx4f5snjei.jpg",
    gallery: [
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743429529/kiota_suit/Leasing/Equipements%20informatiques/impression/Imprimante%20HP%20LaserJet%20Pro/k7o5fhrqhfzfnsllilma.jpg",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743429529/kiota_suit/Leasing/Equipements%20informatiques/impression/Imprimante%20HP%20LaserJet%20Pro/hcwuxdpz4ldst0jhezp2.jpg",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743429528/kiota_suit/Leasing/Equipements%20informatiques/impression/Imprimante%20HP%20LaserJet%20Pro/ahz88di4s70otbacb2n8.jpg",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743429528/kiota_suit/Leasing/Equipements%20informatiques/impression/Imprimante%20HP%20LaserJet%20Pro/xxzokonitpt21gbuhbw7.jpg",
    ],
    price: 200,
    monthlyPayment: 9.99,
    paymentPeriods: "12, 24, 36 mois",
    installmentPayment: { amount: 16.67, period: "mois" },
    category: "informatique",
    subcategory: "impression",
    condition: "new",
    brand: "HP",
    specifications: {
      vitesse: "30 ppm",
      connectivite: "USB, Wi-Fi",
      resolution: "1200 dpi",
    },
    availableFinancing: ["leasing"],
    availableDurations: ["12", "24", "36"],
    stock: 15,
  },
  {
    id: "it-003",
    name: "iPad Pro 12.9”",
    description: "Tablette Apple avec écran Liquid Retina et puce M1",
    image:
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743429835/kiota_suit/Leasing/Equipements%20informatiques/Tablette/iPad%20Pro%2012.9/lubpznwt7hrn01iwmuur.jpg",
    gallery: [
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743429818/kiota_suit/Leasing/Equipements%20informatiques/Tablette/iPad%20Pro%2012.9/yjjkhg72ocdocp0nfebp.jpg",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743429835/kiota_suit/Leasing/Equipements%20informatiques/Tablette/iPad%20Pro%2012.9/eqeeedguednw401lr0ih.jpg",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743429834/kiota_suit/Leasing/Equipements%20informatiques/Tablette/iPad%20Pro%2012.9/qzemdfjz3pztmavrz6rx.jpg",
    ],
    price: 1000,
    monthlyPayment: 49.99,
    category: "informatique",
    subcategory: "tablettes",
    condition: "new",
    brand: "Apple",
    specifications: {
      ecran: "12.9” Liquid Retina",
      stockage: "256 Go",
      connectivite: "Wi-Fi, 5G",
    },
    availableFinancing: ["leasing", "Paiement Échelonné"],
    availableDurations: ["12", "24", "36"],
    stock: 5,
  },
  {
    id: "it-004",
    name: "Imprimante 3D Creality Ender 3 V2",
    description: "Imprimante 3D économique avec haute précision d’impression",
    image:
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743430302/kiota_suit/Leasing/Equipements%20informatiques/impression_3d/Imprimante%203D%20Creality%20Ender%203%20V2/wpuv33v4gv3uuuxjddcz.jpg",
    gallery: [
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743430302/kiota_suit/Leasing/Equipements%20informatiques/impression_3d/Imprimante%203D%20Creality%20Ender%203%20V2/woyddht2wbo3ewuqu6uj.jpg",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743430302/kiota_suit/Leasing/Equipements%20informatiques/impression_3d/Imprimante%203D%20Creality%20Ender%203%20V2/yk9rlqlliryn5sps222a.jpg",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743430302/kiota_suit/Leasing/Equipements%20informatiques/impression_3d/Imprimante%203D%20Creality%20Ender%203%20V2/cnufg2fbflf5kpghtnvp.jpg",
    ],
    price: 250,
    monthlyPayment: 10.99,
    category: "informatique",
    subcategory: "impression_3d",
    condition: "new",
    brand: "Creality",
    specifications: {
      volume: "220 x 220 x 250 mm",
      precision: "0.1 mm",
      materiaux: "PLA, ABS",
    },
    availableFinancing: ["leasing"],
    availableDurations: ["12", "24"],
    stock: 12,
  },
  {
    id: "it-005",
    name: "Drone DJI Phantom 4 Pro",
    description: "Drone professionnel avec caméra 4K et détection d’obstacles",
    image:
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743430661/kiota_suit/Leasing/Equipements%20informatiques/drones/Drone%20DJI%20Phantom%204%20Pro/njic8geqy9odhc6jscrn.jpg",
    gallery: [
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743430661/kiota_suit/Leasing/Equipements%20informatiques/drones/Drone%20DJI%20Phantom%204%20Pro/lbzczqbrgqwo5xpwqbe1.jpg",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743430661/kiota_suit/Leasing/Equipements%20informatiques/drones/Drone%20DJI%20Phantom%204%20Pro/xnoubqytzmaubempibuj.jpg",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743430661/kiota_suit/Leasing/Equipements%20informatiques/drones/Drone%20DJI%20Phantom%204%20Pro/waynos4g3x2mokp7mpq8.jpg",
    ],
    price: 1800,
    monthlyPayment: 75.99,
    category: "informatique",
    subcategory: "drones",
    condition: "new",
    brand: "DJI",
    specifications: {
      camera: "4K UHD",
      autonomie: "30 min",
      portée: "7 km",
    },
    availableFinancing: ["Paiement Échelonné", "leasing"],
    availableDurations: ["12", "24", "36"],
    stock: 3,
  },
  {
    id: "it-006",
    name: "Caméra Sony Alpha 7 IV",
    description:
      "Appareil photo hybride professionnel avec capteur plein format",
    image:
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743430910/kiota_suit/Leasing/Equipements%20informatiques/audiovisuel/Cam%C3%A9ra%20Sony%20Alpha%207%20IV/gshi2b9bz5nxmuumolle.jpg",
    gallery: [
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743430922/kiota_suit/Leasing/Equipements%20informatiques/audiovisuel/Cam%C3%A9ra%20Sony%20Alpha%207%20IV/n7a6nh9rtjvrs58yaett.jpg",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743430946/kiota_suit/Leasing/Equipements%20informatiques/audiovisuel/Cam%C3%A9ra%20Sony%20Alpha%207%20IV/jq0pcsctamdglwvxzdmf.jpg",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743430966/kiota_suit/Leasing/Equipements%20informatiques/audiovisuel/Cam%C3%A9ra%20Sony%20Alpha%207%20IV/wivhmlgmw2q6zwpowiq9.jpg",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743430967/kiota_suit/Leasing/Equipements%20informatiques/audiovisuel/Cam%C3%A9ra%20Sony%20Alpha%207%20IV/nmtdn2n4n2gizlilx5io.jpg",
    ],
    price: 2500,
    monthlyPayment: 99.99,
    category: "informatique",
    subcategory: "audiovisuel",
    condition: "new",
    brand: "Sony",
    specifications: {
      resolution: "33 MP",
      video: "4K 60fps",
      stabilisation: "5 axes",
    },
    availableFinancing: ["Paiement Échelonné", "leasing", "Cash"],
    availableDurations: ["12", "24", "36"],
    stock: 4,
  },

  {
    id: "bu-002",
    name: "Rétroprojecteur Epson ProX",
    description: "Rétroprojecteur haute définition avec connectivité sans fil.",
    image:
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743434095/kiota_suit/Leasing/Equipements%20informatiques/retroprojecteurs/R%C3%A9troprojecteur%20Epson%20ProX/aaqgq7mn4yiq0azppqwl.png",
    gallery: [
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743434104/kiota_suit/Leasing/Equipements%20informatiques/retroprojecteurs/R%C3%A9troprojecteur%20Epson%20ProX/h6q4zvysxt7ls10dqfli.png",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743434104/kiota_suit/Leasing/Equipements%20informatiques/retroprojecteurs/R%C3%A9troprojecteur%20Epson%20ProX/hqwsfp2ak8dmph7amcuz.png",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743434104/kiota_suit/Leasing/Equipements%20informatiques/retroprojecteurs/R%C3%A9troprojecteur%20Epson%20ProX/o20afq4bffregva1hfte.png",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743434104/kiota_suit/Leasing/Equipements%20informatiques/retroprojecteurs/R%C3%A9troprojecteur%20Epson%20ProX/wqoir9medrmpnsszghbz.png",
    ],
    price: 850,
    monthlyPayment: 35.99,
    category: "bureautique",
    subcategory: "retroprojecteurs",
    condition: "new",
    brand: "Epson",
    specifications: {
      resolution: "1080p",
      luminosite: "4000 lumens",
      connectivite: "HDMI, Wi-Fi",
    },
    availableFinancing: ["leasing", "Paiement Échelonné"],
    availableDurations: ["12", "24"],
    stock: 5,
  },

  //MOBILIER ET ACCESSOIRES DE BUREAU
  {
    id: "proj-001",
    name: "Bâche de Projection Portable 100 pouces",
    description:
      "Bâche de projection portable avec support pliable, idéale pour les présentations et formations.",
    image:
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743517713/716JcdlSG6L.__AC_SY300_SX300_QL70_ML2__i2bjrf.jpg",
    gallery: [
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743517709/61iw8aArIOL._AC_SX425__bi70up.jpg",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743517705/71XnplD0drL._AC_SX425__xfakow.jpg",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743517717/6116lOmr2aL._AC_SX425__zwgfkc.jpg",
    ],
    price: 150,
    monthlyPayment: 6.99,
    category: "Mobilier_accessoirs_workspace",
    subcategory: "baches_projection",
    condition: "new",
    brand: "ProjectionPro",
    specifications: {
      taille: "100 pouces",
      materiau: "Tissu PVC",
      compatibilite: "Projecteurs HD et 4K",
    },
    availableFinancing: ["leasing"],
    availableDurations: ["12", "24"],
    stock: 25,
  },
  {
    id: "proj-002",
    name: "Écran Interactif 65 pouces",
    description:
      "Écran interactif tactile pour salles de formation, avec support mural inclus.",
    image:
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743517822/Hda2977cce16b4cb9853fab16c142e824Q_mewaju.png",
    gallery: [
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743517817/H6c00b6d1b5564c0eafb3541407914ef6h_cavc3v.png",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743517813/H06e8642ab8a446f69134d2a3cf5982f8Z_uy8xqx.png",
    ],
    price: 2500,
    monthlyPayment: 99.99,
    category: "Mobilier_accessoirs_workspace",
    subcategory: "ecrans_formation",
    condition: "new",
    brand: "SmartBoard",
    specifications: {
      taille: "65 pouces",
      resolution: "4K UHD",
      connectivite: "HDMI, USB, Wi-Fi",
    },
    availableFinancing: ["leasing", "Paiement Échelonné"],
    availableDurations: ["12", "24", "36"],
    stock: 10,
  },

  //BUREAUTIQUE

  {
    id: "wb-001",
    name: "Tableau Blanc Magnétique 120x90 cm",
    description:
      "Tableau blanc magnétique avec cadre en aluminium et accessoires inclus.",
    image:
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743517656/61UuBz0hhCL._AC_SL1500__gh7wxp.jpg",
    gallery: [
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743517652/61SRjw6-DwL._AC_SL1500__oorzbq.jpg",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743517649/61fty5_OuwL._AC_SL1500__yfiyfk.jpg",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743517660/71Fy6RPt-9L._AC_SL1490__kfsu5f.jpg",
    ],
    price: 100,
    monthlyPayment: 4.99,
    category: "Mobilier_accessoirs_workspace",
    subcategory: "whiteboards",
    condition: "new",
    brand: "OfficeBoard",
    specifications: {
      dimensions: "120x90 cm",
      materiau: "Surface magnétique effaçable",
      accessoires: "Marqueurs, aimants, gomme",
    },
    availableFinancing: ["Cash"],
    availableDurations: ["12", "24"],
    stock: 50,
  },
  {
    id: "mob-001",
    name: "Chaise Ergonomique pour Bureau",
    description:
      "Chaise de bureau avec support lombaire ajustable et accoudoirs.",
    image:
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743517592/pl_1_1_10476_gv6ksy.webp",
    gallery: [
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743517596/pl_1_2_10476_pn0eqp.webp",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743517599/pl_1_3_10476_cddslr.webp",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743517604/pl_1_5_10476_xusvgm.webp",
    ],
    price: 150,
    monthlyPayment: 6.99,
    category: "Mobilier_accessoirs_workspace",
    subcategory: "chaises_bureau",
    condition: "new",
    brand: "ErgoOffice",
    specifications: {
      materiau: "Tissu respirant",
      ajustements: "Hauteur, inclinaison, support lombaire",
    },
    availableFinancing: ["cash"],
    availableDurations: ["12", "24"],
    stock: 50,
  },
  {
    id: "mob-002",
    name: "Table de Réunion en Bois Massif",
    description:
      "Grande table de réunion pour 10 personnes, idéale pour les PME.",
    image:
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743519770/01_robf7g.png",
    gallery: [
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743519772/06_b3uwdk.png",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743519770/02_poew3a.png",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743519770/07_jsjh60.png",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743519774/10_nyhkkw.png",
    ],
    price: 800,
    monthlyPayment: 29.99,
    category: "Mobilier_accessoirs_workspace",
    subcategory: "salles_reunion",
    condition: "new",
    brand: "OfficeLux",
    specifications: {
      dimensions: "3m x 1.2m",
      materiau: "Bois massif",
      couleur: "Chêne clair",
    },
    availableFinancing: ["leasing", "Cash"],
    availableDurations: ["12", "24", "36"],
    stock: 15,
  },
  {
    id: "mob-006",
    name: "Comptoir d’Accueil Moderne",
    description:
      "Comptoir d’accueil avec éclairage LED intégré et espace de rangement.",
    image:
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743517404/bureau_daccueil-deskono-192347z_cmzgdd.jpg",
    gallery: [
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743517402/bureau_daccueil-deskono-192365z_pjoqix.jpg",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743517407/bureau_daccueil-deskono-192356z_elmif3.jpg",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743517411/bureau_daccueil-deskono-192383z_jfslcp.jpg",
    ],
    price: 200,
    monthlyPayment: 29.99,
    category: "Mobilier_accessoirs_workspace",
    subcategory: "accueil_reception",
    condition: "new",
    brand: "ReceptionPro",
    specifications: {
      dimensions: "200x90x110 cm",
      materiau: "Bois et verre",
      couleur: "Blanc et noir",
    },
    availableFinancing: ["leasing", "Cash"],
    availableDurations: ["12", "24", "36"],
    stock: 10,
  },

  // ============ MACHINES OUTILS ============
  // Ajoutez ici d'autres produits de la catégorie "Machines Outils"

  {
    id: "mi-008",
    name: "Tour à métaux manuel",
    description:
      "Tour manuel robuste pour l'usinage de précision des pièces métalliques.",
    image:
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743511024/ED1000GDIG-Tour-a-metaux-a-affichage-Numerique-Entre-poi-show-full_1_uuutdq.jpg",
    gallery: [
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743511024/Tour-a-Metaux-avec-Affichage-Digital-ED1000-GDIG-show-full_lek3h8.jpg",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743511023/ED1000GDIG-Accessoires-fournis-avec-le-tour-a-metaux-show-full_crlutl.jpg",
    ],
    price: 15000,
    monthlyPayment: 399.99,
    paymentPeriods: "12, 24, 36 mois",
    installmentPayment: { amount: 1250, period: "mois" },
    category: "machines_industrielles",
    subcategory: "machines_outils",
    condition: "new",
    brand: "MetalWorks",
    specifications: {
      moteur: "2.2 kW",
      capacité: "Usinage de pièces jusqu'à 300 mm de diamètre",
      vitesse_max: "1500 RPM",
      contrôle: "Manuel",
      précision: "0.05 mm",
    },
    availableFinancing: ["Paiement Échelonné", "leasing"],
    availableDurations: ["12", "24", "36"],
    stock: 6,
  },
  {
    id: "mi-009",
    name: "Fraiseuse manuelle universelle",
    description:
      "Fraiseuse polyvalente pour les travaux d'usinage manuel sur métal et plastique.",
    image:
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743511117/FRAISEUSE_jr7fhb.jpg",
    gallery: [
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743511112/Capture02_lq5yme.png",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743511112/Capture02_lq5yme.png",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743511112/Capture_w3aufi.png",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743511115/Capture044_kyyudi.png",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743511114/Capture05_aekulr.png",
    ],
    price: 12000,
    monthlyPayment: 399.99,
    paymentPeriods: "12, 24, 36 mois",
    installmentPayment: { amount: 1500, period: "mois" },
    category: "machines_industrielles",
    subcategory: "machines_outils",
    condition: "new",
    brand: "PrecisionTools",
    specifications: {
      moteur: "3.0 kW",
      capacité: "Table de 800 x 300 mm",
      vitesse_max: "2000 RPM",
      contrôle: "Manuel",
      précision: "0.02 mm",
    },
    availableFinancing: ["Paiement Échelonné", "leasing"],
    availableDurations: ["12", "24", "36"],
    stock: 4,
  },

  // Équipement de Chantier
  {
    id: "mi-003",
    name: "Pelleteuse Caterpillar 320",
    description:
      "Pelleteuse hydraulique pour travaux de terrassement et de construction",
    image:
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743594283/PELLE_HYDRP_hu0tw1.png",
    gallery: [
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743594282/PE_dg68le.png",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743594281/PELLE_rhhum9.png",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743594282/PELLE_HYDR0_dhzyu2.png",
    ],
    price: 300000,
    monthlyPayment: 3799.99,
    paymentPeriods: "12, 24, 36 mois",
    installmentPayment: { amount: 6666.67, period: "36" },
    category: "machines_industrielles",
    subcategory: "equipement_chantier",
    condition: "new",
    brand: "Caterpillar",
    specifications: {
      moteur: "6.6L Diesel",
      puissance: "150 HP",
      capacité_benne: "1.5 m³",
    },
    availableFinancing: ["Paiement Échelonné", "leasing"],
    availableDurations: ["12", "24", "36"],
    stock: 2,
  },

  {
    id: "mi-011",
    name: "Mélangeur de Béton Auto-Chargeant Tober",
    description:
      "Mélangeur de béton auto-chargeant idéal pour les chantiers de construction, offrant une efficacité et une mobilité accrues.",
    image:
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743684168/Capture_dnsxhs.png",
    gallery: [
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743684170/MEL_pmb4pe.png",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743684166/03_e0fljh.png",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743684164/02_veb5mu.png",
    ],
    price: 5500,
    monthlyPayment: 199.99,
    paymentPeriods: "12, 24, 36 mois",
    installmentPayment: { amount: 7916.67, period: "mois" },
    category: "machines_industrielles",
    subcategory: "equipement_chantier",
    condition: "new",
    brand: "Tober",
    specifications: {
      moteur: "4.5L Diesel",
      puissance: "120 HP",
      capacité_tambour: "3.5 m³",
      vitesse_max: "25 km/h",
      fonctionnalités: [
        "Système de pesée intégré",
        "Rotation à 360° du tambour",
        "Cabine climatisée",
      ],
    },
    availableFinancing: ["Paiement Échelonné", "leasing"],
    availableDurations: ["12", "24", "36"],
    stock: 3,
  },

  // Machines de Production
  {
    id: "mi-004",
    name: "Presses hydrauliques",
    description:
      "Presses à haute capacité pour la fabrication de pièces métalliques",
    image:
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743684168/Capture_dnsxhs.png",
    gallery: [
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743684170/MEL_pmb4pe.png",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743684166/03_e0fljh.png",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743684164/02_veb5mu.png",
    ],
    price: 2000,
    monthlyPayment: 49.99,
    paymentPeriods: "24, 36, 48 mois",
    installmentPayment: { amount: 83.33, period: "mois" },
    category: "machines_industrielles",
    subcategory: "machines_production",
    condition: "new",
    brand: "Industrial Presses Inc.",
    specifications: {
      capacité: "2000 tonnes",
      pression_max: "2000 bar",
      contrôle: "Automatique",
    },
    availableFinancing: ["Paiement Échelonné", "leasing"],
    availableDurations: ["24", "36", "48"],
    stock: 1,
  },

  // Machines Textiles
  {
    id: "mi-005",
    name: "Machine à tisser automatique",
    description: "Machine de production textile pour tissage rapide et précis",
    image:
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743595313/07_u0u84h.png",
    gallery: [
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743595321/10_zy2ztt.png",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743595314/08_cxbflo.png",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743595313/09_x9t7nb.png",
    ],
    price: 25000,
    monthlyPayment: 599.99,
    paymentPeriods: "12, 24, 36 mois",
    installmentPayment: { amount: 2083.33, period: "mois" },
    category: "machines_industrielles",
    subcategory: "machines_textile",
    condition: "new",
    brand: "TextileTech",
    specifications: {
      vitesse_max: "1000 mètres par minute",
      largeur_tissu: "2 m",
      contrôle: "Automatique",
    },
    availableFinancing: ["Paiement Échelonné", "leasing"],
    availableDurations: ["12", "24", "36"],
    stock: 5,
  },

  // Machines de Métallurgie
  {
    id: "mi-006",
    name: "Fours industriels pour fusion de métaux",
    description:
      "Fours à haute température pour la fusion des métaux précieux et industriels",
    image:
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743596237/03_xl96wc.png",
    gallery: [
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743596239/04_azwuon.png",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743596298/05_ffbtg9.png",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743596237/02_xitqf7.png",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743596301/F3_wphyxr.png",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743596304/F6_awl75v.png",
    ],
    price: 1200,
    monthlyPayment: 199.99,
    category: "machines_industrielles",
    subcategory: "machines_metallurgie",
    condition: "new",
    brand: "MetalFusion Corp.",
    specifications: {
      capacité: "10 tonnes",
      température_max: "2000°C",
      source_énergie: "Electrique",
    },
    availableFinancing: ["Paiement Échelonné", "leasing"],
    availableDurations: ["24", "36", "48"],
    stock: 2,
  },

  // Machines Alimentaires

  {
    id: "ag-003",
    name: "Presse à Huile pour Arachide et Tournesol",
    description:
      "Machine compacte pour extraire l'huile des graines comme l'arachide, le soja et le tournesol.",
    image:
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743522310/02_hdnmg2.png",
    gallery: [
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743522310/03_uq13zf.png",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743522310/04_j5cw0v.png",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743522310/Capture_fvxmjn.png",
    ],
    price: 3000,
    monthlyPayment: 79.99,
    category: "machines_industrielles",
    subcategory: "machines_agroalimentaires",
    condition: "new",
    brand: "OilPressTech",
    specifications: {
      capacité: "50 kg/heure",
      puissance: "3 kW",
      rendement: "40-50%",
      usage: "Arachide, soja, tournesol",
    },
    availableFinancing: ["leasing", "Paiement Échelonné"],
    availableDurations: ["12", "24"],
    stock: 8,
  },
  {
    id: "ag-004",
    name: "Ligne de Production de Farine de Manioc",
    description:
      "Équipement complet pour transformer le manioc en farine de haute qualité.",
    image:
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743583343/001_dvlxam.png",
    gallery: [
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743583343/006_rwklsy.jpg",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743583342/002_fjjquq.jpg",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743583342/003_htqvls.jpg",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743583342/005_rpsqv7.jpg",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743583342/004_d7nrwz.jpg",
    ],
    price: 15000,
    monthlyPayment: 399.99,
    category: "machines_industrielles",
    subcategory: "machines_agroalimentaires",
    condition: "new",
    brand: "CassavaTech",
    specifications: {
      capacité: "500 kg/heure",
      étapes: "Lavage, râpage, séchage, broyage",
      énergie: "Électrique",
      usage: "Manioc",
    },
    availableFinancing: ["leasing", "Paiement Échelonné"],
    availableDurations: ["12", "24", "36"],
    stock: 3,
  },
  {
    id: "ag-005",
    name: "Mini-Ligne de Production de Biscuits",
    description:
      "Ligne compacte pour produire des biscuits à base de farine de manioc, maïs ou soja.",
    image:
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743585164/BISCUIT03_f6drfg.jpg",
    gallery: [
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743585165/BISCUIT_yk7b7a.png",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743585166/BISCUIT02_njvbrf.png",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743585168/BISCUIT04_alqtqb.png",
    ],
    price: 4000,
    monthlyPayment: 299.99,
    category: "machines_industrielles",
    subcategory: "machines_agroalimentaires",
    condition: "new",
    brand: "BiscuitLine",
    specifications: {
      capacité: "200 kg/heure",
      étapes: "Mélange, façonnage, cuisson, emballage",
      énergie: "Électrique",
      usage: "Farine de manioc, maïs, soja",
    },
    availableFinancing: ["leasing", "Paiement Échelonné"],
    availableDurations: ["12", "24", "36"],
    stock: 4,
  },
  // ============ OUTILLAGE ============
  // Ajoutez ici d'autres produits de la catégorie "OUTILLAGE"

  //outillage pour électriciens, mécaniciens, plombiers, maçons, etc.

  {
    id: "kit-006",
    name: "Equipement Maintenance Électricité",
    description:
      "Ensemble complet pour les travaux d'électricité industrielle.",
    image:
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743600554/EL_a9yi89.jpg",
    gallery: [
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743600554/02_x4v3hn.png",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743600554/BOITE_lvzmmk.png",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743600554/pince-amperemetrique_zzkhib.jpg",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743600552/_img202107132116381834959996_nkv3zb.jpg",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743600553/FOREUSE_goah3b.png",
    ],
    price: 1000,
    monthlyPayment: 50,
    category: "equipements_professionnels",
    subcategory: "pour_electricite_industrielle",
    condition: "new",
    brand: "IndusElectro",
    specifications: {
      contenu: [
        "- Tableau électrique industriel,",
        "- Multimètre numérique,",
        "- Jeu de tournevis isolés,",
        "- Pince ampèremétrique,",
        "- Câbles haute tension",
      ],
      normes: "CE, ISO 9001",
    },
    availableFinancing: ["Paiement Échelonné", "leasing"],
    availableDurations: ["12", "24", "36"],
    stock: 5,
  },
  {
    id: "kit-008",
    name: "Equipement Atelier Mécanique Automobile",
    description:
      "Équipement complet pour les ateliers de mécanique automobile.",
    image:
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743605069/KITMECA_bipmli.png",
    gallery: [
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743605112/61Lm2_z-t1L._AC_SL1500__a4egze.jpg",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743605067/palan_mecanique_et_portique_jjjkx7.png",
    ],
    price: 15000,
    monthlyPayment: 199.99,
    category: "equipements_professionnels",
    subcategory: "pour_mecanique_automobile",
    condition: "new",
    brand: "AutoMech",
    specifications: {
      contenu: [
        "Pont élévateur",
        "Clé dynamométrique",
        "Compresseur d'air",
        "Jeu de clés à douilles",
        "Analyseur de diagnostic OBD-II",
      ],
      normes: "ISO 9001",
    },
    availableFinancing: ["Paiement Échelonné", "leasing"],
    availableDurations: ["12", "24", "36"],
    stock: 4,
  },
  {
    id: "kit-016",
    name: "Equipement Cordonnerie Professionnelle",
    description:
      "Équipement complet pour les ateliers de cordonnerie, idéal pour la réparation et la fabrication de chaussures.",
    image:
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743683434/_img20230124113544452346185_1_byfzwu.jpg",
    gallery: [
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743683207/machine-a-coudre-claes-moteur-electronique_zvbuxk.jpg",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743683389/cc_li4wex.png",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743683207/pistolet-cloueur-finish-pro-18-mg_soppbd.jpg",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743683206/machine-a-affuter-dick-sm111_ynw8iy.jpg",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743683206/%C3%A9_o8oyhd.jpg",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743683207/presse-manuelle-bl2-avec-pompe-a-pedale_auguvl.jpg",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743683207/Capturee_piv3fk.png",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743683207/machine-a-coudre-claes-moteur-electronique_zvbuxk.jpg",
    ],
    price: 2500,
    monthlyPayment: 69.99,
    category: "equipements_professionnels",
    subcategory: "pour_cordonnerie",
    condition: "new",
    brand: "ShoeFix",
    specifications: {
      contenu: [
        "Machine à coudre pour cuir",
        "Outils de réparation de chaussures",
        "Colles et adhésifs professionnels",
        "Matériaux de semelles",
        "Établi de cordonnier avec rangement",
      ],
      normes: "CE, ISO 9001",
    },
    availableFinancing: ["Paiement Échelonné", "leasing"],
    availableDurations: ["12", "24", "36"],
    stock: 6,
  },
  {
    id: "kit-009",
    name: "Equipement Plomberie Professionnelle",
    description: "Kit complet pour les travaux de plomberie.",
    image:
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743605392/kit-plombier-de-demarrage-d-activite-soudage-cuivre-sertisseuse-l2x-multicouche-virax-stanley-gce-charledave-poste-a-souder-1m-cube_jxkha2.jpg",
    gallery: [
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743605389/kit-plombier-de-demarrage-d-activite-soudage-cuivre-sertisseuse-l2x-multicouche-virax-stanley-gce-charledave-poste-a-souder-1m-cube_2_n0ftah.jpg",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743605387/kit-plombier-de-demarrage-d-activite-soudage-cuivre-sertisseuse-l2x-multicouche-virax-stanley-gce-charledave-poste-a-souder-1m-cube_1_c6marh.jpg",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743605391/kit-plombier-de-demarrage-d-activite-soudage-cuivre-sertisseuse-l2x-multicouche-virax-stanley-gce-charledave-poste-a-souder-1m-cube_4_juum9l.jpg",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743605390/kit-plombier-de-demarrage-d-activite-soudage-cuivre-sertisseuse-l2x-multicouche-virax-stanley-gce-charledave-poste-a-souder-1m-cube_3_cklwu6.jpg",
    ],
    price: 5000,
    monthlyPayment: 125.99,
    category: "equipements_professionnels",
    subcategory: "pour_plomberie",
    condition: "new",
    brand: "PlumbPro",
    specifications: {
      contenu: [
        "Clé à molette",
        "Pince multiprise",
        "Déboucheur à pompe",
        "Soudure et chalumeau",
        "Tuyaux et raccords",
      ],
      normes: "CE",
    },
    availableFinancing: ["Paiement Échelonné", "leasing"],
    availableDurations: ["12", "24"],
    stock: 8,
  },
  {
    id: "kit-010",
    name: "Equipement Salon de Coiffure Professionnel",
    description: "Ensemble complet pour équiper un salon de coiffure.",
    image:
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743606876/_img20230124113544452346185_1_rkqkyt.jpg",
    gallery: [
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743606879/Capture_nwtbdh.png",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1742994662/kiota_suit/Leasing/Equipement%20pour%20un%20salon%20de%20coiffure/S%C3%A8che-cheveux%20%C3%A0%20capuche%20r%C3%A9glable%20sur%20pied%20avec%20roulettes/epfsjje4p1jcptbbvqi8.png",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1742994659/kiota_suit/Leasing/Equipement%20pour%20un%20salon%20de%20coiffure/S%C3%A8che-cheveux%20%C3%A0%20capuche%20r%C3%A9glable%20sur%20pied%20avec%20roulettes/qjavwb2dewockhsjfvsy.png",
    ],
    price: 4500,
    monthlyPayment: 149.99,
    category: "equipements_professionnels",
    subcategory: "pour_coiffure_professionnelle",
    condition: "new",
    brand: "HairPro",
    specifications: {
      contenu: [
        "Fauteuil de coiffure",
        "Sèche-cheveux professionnel",
        "Tondeuse électrique",
        "Ciseaux de coiffure",
        "Bac à shampoing",
      ],
      normes: "CE",
    },
    availableFinancing: ["Paiement Échelonné", "leasing"],
    availableDurations: ["12", "24", "36"],
    stock: 6,
  },
  {
    id: "kit-011",
    name: "Equipement Atelier de Couture Professionnel",
    description: "Equipement Atelier de Couture Professionnelle",
    image:
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743608082/pack-de-demarrage-atelier-de-couture-1_1_bzrr45.jpg",
    gallery: [
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743607892/PR1055X_main_yapn0o.png",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743607892/machine-ourlet-invisible-tony-cm500-1_jywfjl.jpg",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743607892/recouvreuse-janome-2000-cpx-3_ipvggi.jpg",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743607892/table-aspirante-soufflante-auto.-1_bh8hcr.jpg",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743607892/mannequin-de-couture-ajustable-olivia-1_pzellw.jpg",
    ],
    price: 4500,
    monthlyPayment: 149.99,
    category: "equipements_professionnels",
    subcategory: "pour_couture_professionnelle",
    condition: "new",
    brand: "SewPro",
    specifications: {
      contenu: [
        "Machine à coudre industrielle",
        "Table de coupe",
        "Ciseaux de couture",
        "Mannequin de couture",
        "Boîte à fils et aiguilles",
      ],
      normes: "CE",
    },
    availableFinancing: ["Paiement Échelonné", "leasing"],
    availableDurations: ["12", "24"],
    stock: 10,
  },
  {
    id: "kit-012",
    name: "Equipement de Restauration Rapide",
    description: "Équipement complet pour un service de restauration rapide.",
    image:
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743675874/03_x1zhkt.png",
    gallery: [
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743675878/Capture_rrkg2z.png",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743675875/05_bclkip.png",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743675874/02_vd5wgw.png",
    ],
    price: 10000,
    monthlyPayment: 499.99,
    category: "equipements_professionnels",
    subcategory: "pour_restauration_rapide",
    condition: "new",
    brand: "FastFoodPro",
    specifications: {
      contenu: [
        "Friteuse professionnelle",
        "Grill électrique",
        "Plancha à gaz",
        "Réfrigérateur commercial",
        "Évier avec robinetterie",
      ],
      normes: "CE, HACCP",
    },
    availableFinancing: ["Paiement Échelonné", "leasing"],
    availableDurations: ["12", "24", "36"],
    stock: 5,
  },
  {
    id: "kit-018",
    name: "Equipement cabinet d'Ophtalmologie moderne",
    description:
      "Équipement complet pour un cabinet d'ophtalmologie professionnel.",
    image:
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743609493/MASTER4-FULL04_bp8eut.jpg",
    gallery: [
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743609492/0000111_unite-de-consultation-ost-350_550_eh05xz.png",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743609491/705_Trousse_de_diagnostic_big_1_oun8fp.jpg",
    ],
    price: 45000,
    monthlyPayment: 1149.99,
    category: "equipements_professionnels",
    subcategory: "pour_ophtalmologie",
    condition: "new",
    brand: "VisionCare",
    specifications: {
      contenu: [
        "Lampe à fente",
        "Réfracteur manuel",
        "Projecteur de test visuel",
        "Tonomètre",
        "Chaise et unité ophtalmologique",
        "Table d'examen réglable",
        "Ophthalmoscope",
        "Kératomètre",
        "Système de gestion des dossiers patients",
      ],
      normes: "CE, ISO 13485",
    },
    availableFinancing: ["Paiement Échelonné", "leasing"],
    availableDurations: ["24", "36", "48"],
    stock: 3,
  },
  {
    id: "kit-019",
    name: "Equipement Cabinet de Dermatologie Moderne",
    description:
      "Équipement complet pour un cabinet de dermatologie professionnel.",
    image:
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743677144/DER_pzcqy4.jpg",
    gallery: [
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743677144/101834-0-dermlite-dl4-dermatoskop-02_ibvipq.jpg",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743677145/Capture_e69hv2.png",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743674789/LAMPE_nfya2g.png",
    ],
    price: 9000,
    monthlyPayment: 299.99,
    category: "equipements_professionnels",
    subcategory: "pour_dermatologie",
    condition: "new",
    brand: "SkinCarePro",
    specifications: {
      contenu: [
        "Dermatoscope",
        "Lampe d'examen LED",
        "Cryothérapie portable",
        "Lit d'examen réglable",
        "Laser dermatologique",
        "Système de gestion des dossiers patients",
        "Microscope pour biopsies",
        "Équipement de peeling chimique",
        "Appareil de radiofréquence pour traitements esthétiques",
      ],
      normes: "CE, ISO 13485",
    },
    availableFinancing: ["Paiement Échelonné", "leasing"],
    availableDurations: ["24", "36", "48"],
    stock: 4,
  },
  {
    id: "kit-020",
    name: "Equipement pour Vétérinaire",
    description:
      "Équipement complet pour une clinique vétérinaire professionnelle.",
    image:
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743684798/02_ny3w89.png",
    gallery: [
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743684800/04_xe9nsh.png",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743684804/set-tete-fendue-et-ophtalmoscope-beta-200-veterinaire-heine_bvtjyn.jpg",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743684806/VET02_h1rvcg.png",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743684804/set-tete-fendue-et-ophtalmoscope-beta-200-veterinaire-heine_bvtjyn.jpg",
    ],
    price: 10000,
    monthlyPayment: 300,
    category: "equipements_professionnels",
    subcategory: "pour_veterinaire",
    condition: "new",
    brand: "VetCare",
    specifications: {
      contenu: [
        "Table d'examen vétérinaire",
        "Appareil d'échographie portable",
        "Stérilisateur à autoclave",
        "Lampe chirurgicale mobile",
        "Kit de chirurgie vétérinaire",
        "Cages pour hospitalisation des animaux",
        "Système de radiographie numérique",
        "Pompe à perfusion",
        "Microscope pour analyses biologiques",
        "Système de gestion des dossiers patients",
      ],
      normes: "CE, ISO 13485",
    },
    availableFinancing: ["Paiement Échelonné", "leasing"],
    availableDurations: ["24", "36", "48"],
    stock: 2,
  },

  {
    id: "kit-014",
    name: "Equipement Dentisterie",
    description: "Équipement complet pour un cabinet dentaire professionnel.",
    image:
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743608881/unite-dentaire-high-pack-cabinet.dentaire-complet_0_0_n9im0v.jpg",
    gallery: [
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743608864/fauteuil-dentaire-flex-up-high-bader_0_kdbyi3.jpg",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743608864/pack-cabinet-dentaire-complet-divers_1_iixmxg.jpg",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743608864/299566-16490700_xfoaxv.jpg",
    ],
    price: 5000,
    monthlyPayment: 249.99,
    category: "equipements_professionnels",
    subcategory: "pour_dentisterie",
    condition: "new",
    brand: "DentalPro",
    specifications: {
      contenu: [
        "Fauteuil dentaire",
        "Lampe scialytique",
        "Compresseur d'air",
        "Unit dentaire avec instruments",
        "Autoclave pour stérilisation",
      ],
      normes: "CE, ISO 13485",
    },
    availableFinancing: ["Paiement Échelonné", "leasing"],
    availableDurations: ["24", "36", "48"],
    stock: 4,
  },
  {
    id: "kit-015",
    name: "Equipement Entretien de Surface",
    description:
      "Ensemble complet pour le nettoyage et l'entretien des surfaces.",
    image:
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743678300/kit-de-demarrage-entreprise-de-nettoyage_nfgeca.jpg",
    gallery: [
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743678300/kit-de-demarrage-entreprise-de-nettoyage_1_cayfda.jpg",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743678300/kit-de-demarrage-entreprise-de-nettoyage_3_hhnir3.jpg",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743678300/kit-de-demarrage-entreprise-de-nettoyage_2_vldqbx.jpg",
    ],
    price: 800,
    monthlyPayment: 19.99,
    category: "equipements_professionnels",
    subcategory: "pour_entretien_surface",
    condition: "new",
    brand: "CleanPro",
    specifications: {
      contenu: [
        "Aspirateur industriel",
        "Nettoyeur haute pression",
        "Chariot de nettoyage",
        "Produits détergents",
        "Balais et serpillières",
      ],
      normes: "CE",
    },
    availableFinancing: ["Paiement Échelonné", "leasing"],
    availableDurations: ["12", "24"],
    stock: 10,
  },

  // ============ AGRICULTURE ============
  // Ajoutez ici d'autres produits de la catégorie "AGRICULTURE"
  {
    id: "ag-0010",
    name: "Tracteur John Deere 5050E",
    description:
      "Tracteur agricole polyvalent, idéal pour le labour, la culture, et l’entretien des champs",
    image:
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743686422/43936090_1691541453_682_ttezep.jpg",
    gallery: [
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743686418/43936090_1691541453_584_hi7tr2.jpg",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743686417/43936090_1691541453_290_b3sdmk.jpg",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743686416/43936090_1691541453_257_rdjydj.jpg",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743686415/43936090_1691541453_113_dignj7.jpg",
    ],
    price: 10000,
    monthlyPayment: 299.99,
    category: "agriculture",
    subcategory: "machines_agricoles",
    condition: "occasion",
    brand: "John Deere",
    specifications: {
      puissance: "50 ch",
      moteur: "Diesel",
      transmission: "Manuelle 4 vitesses",
    },
    availableFinancing: ["Paiement Échelonné", "leasing"],
    availableDurations: ["12", "24", "36"],
    stock: 4,
  },
  {
    id: "ag-001",
    name: "Motoculteur Multifonctionnel 7HP",
    description:
      "Motoculteur polyvalent pour le labour, le sarclage et le transport agricole.",
    image:
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743520440/04_czesbc.png",
    gallery: [
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743520439/3_lpzmnc.png",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743520439/02_r8htqe.png",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743520438/03_cjr3h5.png",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743520436/01_ifux26.png",
    ],
    price: 1500,
    monthlyPayment: 59.99,
    category: "agriculture",
    subcategory: "machines_agricoles",
    condition: "new",
    brand: "AgriTech",
    specifications: {
      moteur: "7 HP Diesel",
      largeur_labour: "80 cm",
      profondeur_labour: "15 cm",
      accessoires: "Remorque, charrue, sarcleuse",
    },
    availableFinancing: ["Paiement Échelonné", "credit"],
    availableDurations: ["12", "24"],
    stock: 10,
  },

  {
    id: "ag-002",
    name: "Moissonneuse-Batteuse Compacte 4LZ-1.0",
    description:
      "Moissonneuse-batteuse compacte adaptée aux petites exploitations agricoles.",
    image:
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743521616/04_hhfmfy.png",
    gallery: [
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743521616/02_m6kihf.png",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743521094/03_tl9lyz.png",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743521093/01_dczqk9.png",
    ],
    price: 8000,
    monthlyPayment: 199.99,
    category: "machines_industrielles",
    subcategory: "machines_agricoles",
    condition: "new",
    brand: "AgriHarvest",
    specifications: {
      capacité: "1 tonne/heure",
      moteur: "20 HP Diesel",
      largeur_coupe: "1.2 m",
      usage: "Maïs, manioc, soja",
    },
    availableFinancing: ["Paiement Échelonné", "credit"],
    availableDurations: ["12", "24"],
    stock: 5,
  },
  {
    id: "ag-002",
    name: "Moissonneuse-batteuse Case IH",
    description:
      "Moissonneuse-batteuse de haute capacité pour récoltes de céréales",
    image:
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743586599/01%C2%B5_m8mdqe.png",
    gallery: [
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743586599/01%C2%B5_m8mdqe.png",
    ],
    price: 120000,
    monthlyPayment: 2999.99,
    category: "agriculture",
    subcategory: "machines_agricoles",
    condition: "new",
    brand: "Case IH",
    specifications: {
      capacité_de_récolte: "50 tonnes/h",
      moteur: "250 ch",
      type: "Autotractée",
    },
    availableFinancing: ["Paiement Échelonné", "leasing"],
    availableDurations: ["24", "36", "48"],
    stock: 2,
  },
  // Machines Agricoles
  {
    id: "mi-002",
    name: "Tracteur Massey Ferguson 4707",
    description: "Tracteur tout-terrain puissant pour les travaux agricoles",
    image:
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743510507/20171010_142338_resized_hy3ffs.jpg",
    gallery: [
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743510505/20171010_142400_resized_tpl28w.jpg",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743510505/20171010_142406_resized_bvaq92.jpg",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743510504/20171010_142345_resized_ajfqns.jpg",
    ],
    price: 42000,
    monthlyPayment: 899.99,
    paymentPeriods: "12, 24, 36 mois",
    installmentPayment: { amount: 3500, period: "mois" },
    category: "agriculture",
    subcategory: "machines_agricoles",
    condition: "new",
    brand: "Massey Ferguson",
    specifications: {
      moteur: "4.4L Diesel",
      puissance: "95 HP",
      capacité: "Tête de fauche et remorque",
    },
    availableFinancing: ["Paiement Échelonné", "leasing"],
    availableDurations: ["12", "24", "36"],
    stock: 3,
  },

  // Équipements d'Élevage
  {
    id: "ag-008",
    name: "Trayeuse Automatique DeLaval",
    description:
      "Trayeuse automatique pour un rendement élevé et une gestion optimale de l’élevage laitier",
    image:
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743688355/TR_lqxy8q.png",
    gallery: [
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743688327/04_e17b3l.png",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743688326/Capture_b1ttd3.png",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743688326/05_gqjhdb.png",
    ],
    price: 3000,
    monthlyPayment: 149.99,
    category: "agriculture",
    subcategory: "equipements_elevage",
    condition: "new",
    brand: "DeLaval",
    specifications: {
      type: "Trayeuse à vache",
      capacité: "12 vaches",
      caractéristiques: "Contrôle de la température, système d’aspiration doux",
    },
    availableFinancing: ["Paiement Échelonné", "leasing"],
    availableDurations: ["12", "24"],
    stock: 5,
  },

  // Stockage Agricole
  {
    id: "ag-009",
    name: "Silo de Stockage Céréales",
    description: "Silo en métal pour le stockage sécurisé des céréales",
    image:
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743689727/04_zydzpa.png",
    gallery: [
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743689718/02%C2%B5_sly7vi.png",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743689718/03_jlydxz.png",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743689728/Capture_xmfkf1.png",
    ],
    price: 5000,
    monthlyPayment: 59.99,
    category: "agriculture",
    subcategory: "stockage_agricole",
    condition: "new",
    brand: "SiloTech",
    specifications: {
      capacité: "50 tonnes",
      matériau: "Acier galvanisé",
      dimensions: "5m x 3m x 10m",
    },
    availableFinancing: ["credit_bail", "leasing"],
    availableDurations: ["12", "24", "36"],
    stock: 6,
  },

  // ============ EAU & ENERGIE ============
  // Ajoutez ici d'autres produits de la catégorie "EAU & ENERGIE"

  {
    id: "ee-003",
    name: "Station de Pompage Mobile Borra",
    description:
      "Station de pompage d'eau mobile et robuste, idéale pour les PME agricoles et industrielles. Facile à installer et à déplacer.",
    image: "https://res.cloudinary.com/daxvxdecv/image/upload/v1743766941/Station_de_Pompage_D_eau_Mobile_borra_pzopkh.png",
    gallery: [
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743766942/03_g11btp.png",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743766942/%C3%A0%C3%A9_qdo8ba.png",
    ],
    price: 3000,
    monthlyPayment: 83.33,
    paymentPeriods: "12, 24, 36 mois",
    installmentPayment: { amount: 250, period: "mois" },
    category: "energie_eau",
    subcategory: "pompage",
    condition: "new",
    brand: "AquaPumps",
    specifications: {
      puissance: "7.5 kW",
      debit: "5000 L/h",
      typePompe: "Centrifuge auto-amorçante",
      materiauCorps: "Fonte",
      typeControle: "Automatique avec flotteur",
      raccordements: "Entrée/Sortie 2 pouces",
      chassis: "Acier galvanisé sur remorque",
    },
    availableFinancing: ["Paiement Échelonné", "leasing"],
    availableDurations: ["12", "24", "36"],
    stock: 5,
  },
  {
    id: "ee-004",
    name: "Système d′énergie solaire à demi-cellule xn-solaire",
    description:
      "Système d'énergie solaire hors réseau de 10kW avec stockage, idéal pour les PME et les applications résidentielles.",
    image: "https://res.cloudinary.com/daxvxdecv/image/upload/v1743769077/Household-Solar-Mini-Solar-Power-Plant-Solar-Energy-Systems-off-Grid10kw-20kw-30kw-Energy-Storage-System-Solar-Power_uzseka.png",
    gallery: [
      
    ],
    price: 3288,
    monthlyPayment: 91.33,
    paymentPeriods: "12, 24, 36 mois",
    installmentPayment: { amount: 274, period: "mois" },
    category: "energie_eau",
    subcategory: "solaire",
    condition: "new",
    brand: "SolarTech",
    specifications: {
      puissance: "10 kW",
      type: "Hors réseau",
      stockage: "Batteries lithium-ion incluses",
      panneauxSolaires: "Panneaux monocristallins haute efficacité",
      onduleur: "Onduleur hybride intégré",
      duréeDeVie: "25 ans (panneaux), 10 ans (batteries)",
    },
    availableFinancing: ["Paiement Échelonné", "leasing"],
    availableDurations: ["12", "24", "36"],
    stock: 10,
  },
  {
    id: "ee-005",
    name: "Foreuse Hydraulique Compacte HydroDrill 150",
    description:
      "Foreuse hydraulique compacte et facile à transporter, conçue pour le forage de puits d'eau pour les PME agricoles et les communautés.",
    image: "https://res.cloudinary.com/daxvxdecv/image/upload/v1743769711/01_irevzd.png",
    gallery: [
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743769716/07_yoprot.png",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743769714/09_nrw5e9.png",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743769713/08_tbcixa.png",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743769712/06_pifcom.png",
    ],
    price: 35000,
    monthlyPayment: 972.22,
    paymentPeriods: "12, 24, 36, 48 mois",
    installmentPayment: { amount: 2916.67, period: "mois" },
    category: "energie_eau",
    subcategory: "forage",
    condition: "new",
    brand: "DrillTech",
    specifications: {
      profondeurMaximale: "150 mètres",
      diametreForage: "75 - 200 mm",
      typeMoteur: "Hydraulique, 55 kW",
      systemeForage: "Rotatif avec tête d'injection",
      vitesseRotation: "0 - 150 tr/min",
      forceTraction: "10 tonnes",
      pompeInjection: "Pompe à boue 1000 L/h, 20 bar",
      chassis: "Monté sur remorque tout-terrain",
    },
    availableFinancing: ["Paiement Échelonné", "leasing"],
    availableDurations: ["12", "24", "36", "48"],
    stock: 1,
  },
  {
    id: "ee-006",
    name: "Kit d'Irrigation Solaire AgroFlow 5",
    description:
      "Système d'irrigation solaire complet et prêt à l'emploi pour les petites et moyennes exploitations agricoles. Comprend pompe, panneaux solaires et système de contrôle.",
    image: "https://res.cloudinary.com/daxvxdecv/image/upload/v1743771555/Capture_r76qrn.png",
    gallery: [
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743771552/05_z488f4.png",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743771554/06_lpmmkx.png",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743771550/03_tbs2jr.png",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743771713/09_piqcu2.png",
    ],
    price: 2000,
    monthlyPayment: 33.33,
    paymentPeriods: "12, 24, 36 mois",
    installmentPayment: { amount: 1000, period: "mois" },
    category: "energie_eau",
    subcategory: "irrigation_solaire",
    condition: "new",
    brand: "AgriSolar",
    specifications: {
      puissancePompe: "3 kW",
      debitMaximal: "25000 L/h",
      hauteurRefoulementMaximale: "40 mètres",
      panneauxSolaires: "9 x 330W, monocristallin",
      surfacePanneaux: "15 m²",
      controleur: "Contrôleur d'irrigation programmable AgroFlow 5",
      capteursHumiditeSol: "3 capteurs sans fil",
      systemeDistribution: "Tuyaux PVC et goutteurs intégrés (5 hectares)",
    },
    availableFinancing: ["Paiement Échelonné", "leasing"],
    availableDurations: ["12", "24", "36"],
    stock: 4,
  },
  {
    id: "ee-009",
    name: "Kit d'Irrigation Goutte à Goutte SolarFlow 3",
    description:
      "Système d'irrigation goutte à goutte alimenté par énergie solaire, idéal pour les petites et moyennes exploitations agricoles. Comprend pompe, panneaux solaires et accessoires d'irrigation.",
    image: "https://res.cloudinary.com/daxvxdecv/image/upload/v1743772251/kit-pompage-solaire-immerge-goutte-a-goutte-sans-pression-100m2-70m-2m3_1_my0ddx.jpg",
    gallery: [
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743772251/kit-pompage-solaire-immerge-goutte-a-goutte-sans-pression-100m2-70m-2m3_3_f9c60a.jpg",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743772251/kit-pompage-solaire-immerge-goutte-a-goutte-sans-pression-100m2-70m-2m3_shwwdi.jpg",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743772251/kit-pompage-solaire-immerge-goutte-a-goutte-sans-pression-100m2-70m-2m3_2_gdelfp.jpg"
    ],
    price: 2500,
    monthlyPayment: 69.44,
    paymentPeriods: "12, 24, 36 mois",
    installmentPayment: { amount: 833.33, period: "mois" },
    category: "energie_eau",
    subcategory: "irrigation_solaire",
    condition: "new",
    brand: "AgriSolar",
    specifications: {
      puissancePompe: "2.5 kW",
      debitMaximal: "20000 L/h",
      hauteurRefoulementMaximale: "30 mètres",
      panneauxSolaires: "8 x 300W, monocristallin",
      surfacePanneaux: "12 m²",
      controleur: "Contrôleur d'irrigation programmable SolarFlow 3",
      capteursHumiditeSol: "2 capteurs sans fil",
      systemeDistribution: "Tuyaux PVC et goutteurs intégrés (3 hectares)",
      accessoires: "Filtres, régulateurs de pression, vannes d'arrêt"
    },
    availableFinancing: ["Paiement Échelonné", "leasing"],
    availableDurations: ["12", "24", "36"],
    stock: 5
  },

  // ============ EVENEMENTIEL ============
  // Ajoutez ici d'autres produits de la catégorie "EVENEMENTIEL"

  {
    id: "ev-001",
    name: "Tente de Réception 10x20m",
    description:
      "Tente de réception spacieuse pour grands événements, idéale pour mariages, salons et événements en extérieur.",
    image:
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743694727/Capture_lc7hyh.png",
    gallery: [
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743694726/02_uhwd6y.png",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743694724/10x20-600x494_svfpzq.jpg",
    ],
    price: 3500,
    monthlyPayment: 89.99,
    category: "evenementiel",
    subcategory: "tentes",
    condition: "new",
    brand: "EventTents",
    specifications: {
      dimensions: "10x20m",
      matériau: "Polyéthylène",
      type: "Tente de Réception",
      capacité: "200 personnes",
    },
    availableFinancing: ["Paiement Échelonné", "leasing"],
    availableDurations: ["12", "24"],
    stock: 4,
  },
  {
    id: "ev-002",
    name: "Tente Pliante 3x3m",
    description:
      "Tente pliante légère et portable, idéale pour les événements plus petits, les stands et les expositions.",
    image:
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743694780/001_i8vz2p.jpg",
    gallery: [
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743694783/002_ejzeo9.jpg",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743694786/003_oliibf.jpg",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743694789/004_b9e1ec.jpg",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743694789/004_b9e1ec.jpg",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743694797/008_rxxi60.jpg",
    ],
    price: 250,
    monthlyPayment: 9.99,
    category: "evenementiel",
    subcategory: "tentes",
    condition: "new",
    brand: "QuickShade",
    specifications: {
      dimensions: "3x3m",
      matériau: "Polyester",
      type: "Tente Pliante",
      capacité: "10-15 personnes",
    },
    availableFinancing: ["Paiement Échelonné", "leasing"],
    availableDurations: ["12"],
    stock: 20,
  },

  // Sonorisation
  {
    id: "ev-003",
    name: "Système de Sonorisation JBL EON615",
    description:
      "Système de sonorisation portable avec des haut-parleurs puissants, idéal pour les événements en intérieur et extérieur.",
    image: "https://res.cloudinary.com/daxvxdecv/image/upload/v1743695630/Capture_vh7snq.png",
    gallery: [
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743695401/05_qmol3k.png",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743695398/03_j2a7m6.png",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743695398/02_usyde2.png",
    ],
    price: 1500,
    monthlyPayment: 59.99,
    category: "evenementiel",
    subcategory: "sonorisation",
    condition: "new",
    brand: "JBL",
    specifications: {
      puissance: "1000W",
      type: "Haut-parleur actif",
      connectivité: "Bluetooth, XLR, RCA",
      usage: "Événements Intérieurs et Extérieurs",
    },
    availableFinancing: ["Paiement Échelonné", "leasing"],
    availableDurations: ["12", "24"],
    stock: 5,
  },
  {
    id: "ev-004",
    name: "Pack Sonorisation Bose L1 Compact",
    description:
      "Pack de sonorisation portable avec système de ligne de source et subwoofer intégré pour des performances audio de qualité.",
    image: "https://res.cloudinary.com/daxvxdecv/image/upload/v1743781073/SON_cuurqi.jpg",
    gallery: [
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743781073/Capture_aqb44e.png",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743781073/MICRO_g2jnsi.png",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743781071/01_qw9xi7.jpg",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743781071/71GVeJDUGvL._AC_SL1500__mnhkp7.jpg",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743781073/GROUPE_cze4q8.png",
    ],
    price: 2200,
    monthlyPayment: 54.99,
    category: "evenementiel",
    subcategory: "sonorisation",
    condition: "new",
    brand: "Bose",
    specifications: {
      puissance: "200W",
      type: "Système de Ligne de Source",
      connectivité: "Bluetooth, XLR",
      usage: "Concerts, Conférences",
    },
    availableFinancing: ["Paiement Échelonné", "leasing"],
    availableDurations: ["12", "24"],
    stock: 3,
  },

  //Evénementiel

  {
    id: "ev-008",
    name: "Podium Métallique Démontable 8x6m",
    description:
      "Podium métallique démontable, léger et modulable, conçu pour les événements extérieurs. Facile à transporter et à assembler.",
    image:
      
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743775799/007_etdirx.png",
    gallery: [
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743775984/000_bme0nm.png",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743775799/003_ubhigh.png",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743775800/05_z7swuk.png",
      "https://res.cloudinary.com/daxvxdecv/image/upload/v1743775797/001_w8vzzh.png",
    ],
    price: 4500,
    monthlyPayment: 179.99,
    category: "evenementiel",
    subcategory: "tentes",
    condition: "new",
    brand: "EventPodium",
    specifications: {
      dimensions: "8x6m",
      matériau: "Métal et Aluminium",
      capacité: "500 personnes",
      poids: "350 kg",
      usage: "Concerts, Événements Extérieurs",
    },
    availableFinancing: ["Paiement Échelonné", "leasing"],
    availableDurations: ["12", "24"],
    stock: 2,
  },
];
